import request from '../../axios';

const getViolationReason = async (type: string) => {
  const {data}: {data: IViolationReason[]} = await request.get(
    `api/v2/store/reason-report-advertisement?reason_type=${type}`,
  );
  return data;
};

export default getViolationReason;
